// extracted by mini-css-extract-plugin
export var quantityInput = "_fv-0";